"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "Admin";
    UserRole["MarchingOrderAdmin"] = "MarchingOrderAdmin";
    UserRole["HerffJonesAdmin"] = "HerffJonesAdmin";
    UserRole["Clipper"] = "Clipper";
    UserRole["LimitedClipper"] = "LimitedClipper";
    UserRole["ReadOnly"] = "ReadOnly";
    UserRole["User"] = "User";
    UserRole["Producer"] = "Producer";
    UserRole["InstitutionAdmin"] = "InstitutionAdmin";
    UserRole["Api"] = "Api";
    UserRole["AVUser"] = "AVUser";
    UserRole["NameReadingAdmin"] = "NameReadingAdmin";
    UserRole["NameReadingReviewer"] = "NameReadingReviewer";
    UserRole["SelfUser"] = "SelfUser";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
//# sourceMappingURL=user-role.js.map